import DOMPurify from 'dompurify'

export const cleanText = (dirtyText: string) => DOMPurify.sanitize(dirtyText)
